import { createSelector } from 'reselect';

/**
 * Direct selector to the homePage state domain
 */
const selectForgotPasswordPageDomain = () => state => state.forgotPassword;

/**
 * Other specific selectors
 */

const selectComponentToRender = () => createSelector(
  selectForgotPasswordPageDomain(),
  substate => substate.componentToRender
)

const selectHasRpsPasswordError = () =>
  createSelector(
    selectForgotPasswordPageDomain(),
    (substate) => substate.hasRpsPasswordError
  );
/**
 * Default selector used by ForgotPasswordPage
 */

const selectForgotPasswordPage = () => createSelector(
  selectForgotPasswordPageDomain(),
  (substate) => substate
);

export default selectForgotPasswordPage;
export {
  selectForgotPasswordPageDomain,
  selectComponentToRender,
  selectHasRpsPasswordError,
};



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/selectors.js